<template>
  <v-row dense class="pa-2">
    <v-col cols="12" md="6">
      <v-text-field
        v-model="data.baleId"
        append-icon="mdi-at"
        label="شناسه بله (Username یا آیدی کانال)"
        placeholder="channel_id"
        prefix="ble.ir/"
        dir="ltr"
        outlined
        dense
        hint="شناسه را بدون @ یا آدرس کامل وارد کنید"
        persistent-hint
      />
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="data.organizationName"
        append-icon="mdi-format-title"
        label="عنوان نمایشی کانال / کسب‌وکار"
        placeholder="مثال: کانال رسمی اطلاع‌رسانی"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12">
      <v-text-field
        v-model="data.subtitle"
        label="زیرعنوان / شعار کوتاه"
        placeholder="مثال: مرجع جدیدترین تخفیف‌ها و رویدادها"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12">
      <v-textarea
        v-model="data.aboutUs"
        label="متن بیو و توضیحات کامل"
        placeholder="توضیحات و پیام خوش‌آمدگویی..."
        rows="3"
        outlined
        dense
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "BaleBaseInfo",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
